var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import bridge from '@funny/bridge';
import { env } from '@funny/env';
import { upload } from '@funny/request';
import { nanoid } from 'nanoid';
import { format } from './datetime';
var canvasId = null;
// File对象继承自Blob对象，因此不需要考虑File和Blob的互转，直接调用
/**
 * base64 转换成 Blob 对象
 * @param dataUrl
 * @returns
 */
export function base64ToBlob(dataUrl) {
    var _a;
    if (dataUrl.indexOf(',') < 0) {
        console.warn('the method parsed string must provide mine-type declare on base64 string');
        return null;
    }
    var arr = dataUrl.split(',');
    var mime = (_a = arr[0].match(/:(.*?);/)) === null || _a === void 0 ? void 0 : _a[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
/**
 * base64 转化成 File 对象
 * @param dataUrl
 * @param filename
 * @returns
 */
export function base64ToFile(dataUrl, filename) {
    var blob = base64ToBlob(dataUrl);
    if (!blob) {
        return null;
    }
    return new File([blob], filename, {
        type: blob.type,
    });
}
/**
 * blob对象转base64
 * @param blob
 * @returns
 */
export function blobToBase64(blob, ignoreMimiType) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () {
            var result = reader.result;
            // 忽略掉跟mime-type相关的字符串
            if (ignoreMimiType) {
                result = result.split(',')[1];
            }
            resolve(result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}
/**
 * File 对象转 base64
 * @param file
 */
export function fileToBase64(file) {
    return blobToBase64(file);
}
/**
 * 将base64以文件的形式下载到本地
 * @param base64Str base64数据源
 * @param filename 文件名
 */
export function downloadBase64(base64Str, filename) {
    var blob = base64ToBlob(base64Str);
    downloadBlob(blob, filename);
}
/**
 * 浏览器下载 Blob 二进制大型对象，导出为指定格式
 * @param blob 数据源
 * @param filename 保存文件名称
 */
export function downloadBlob(blob, filename) {
    return new Promise(function (resolve, reject) {
        var urlObj = window.URL || window.webkitURL;
        if (!urlObj || typeof Blob === 'undefined') {
            reject(new Error('当前JS环境无法导出!'));
        }
        try {
            // 对于IE10以上
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            }
            else {
                var fakeEle = document.createElement('a');
                var href = urlObj.createObjectURL(blob);
                fakeEle.href = href;
                fakeEle.download = filename;
                fakeEle.click();
                urlObj.revokeObjectURL(href);
            }
            resolve();
        }
        catch (exp) {
            reject(exp);
        }
    });
}
/**
 * 浏览器下载 File 对象，导出为指定格式
 * @param blob 数据源
 * @param filename 保存文件名称
 */
export function downloadFile(file, filename) {
    return downloadBlob(file, filename);
}
/**
 * 将以el为根节点的一段DOM子树转为canvas元素
 * @param el 源节点
 * @returns
 */
export function takeHtmlSnapshoot(el) {
    return __awaiter(this, void 0, void 0, function () {
        var html2canvas, exp_1, canvas, id, inTreeEl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, import('html2canvas')];
                case 1:
                    html2canvas = (_a.sent()).default;
                    return [3 /*break*/, 3];
                case 2:
                    exp_1 = _a.sent();
                    throw new Error('can not take element snapshoot, please install html2canvas');
                case 3: return [4 /*yield*/, html2canvas(el, {
                        useCORS: true,
                        width: el.offsetWidth,
                        height: el.offsetHeight,
                    })];
                case 4:
                    canvas = _a.sent();
                    canvasId = 'canvas' + Math.floor(Math.random() * 1000);
                    id = canvasId;
                    canvas.id = id;
                    canvas.style.width = '0';
                    canvas.style.height = '0';
                    document.body.appendChild(canvas);
                    inTreeEl = document.querySelector('#' + id);
                    return [2 /*return*/, inTreeEl.toDataURL('image/png')];
            }
        });
    });
}
/**
 * 将以el为根节点的一段DOM子树转为图片保存在本地
 * @param el 需要存储的根节点
 * @param filename 需要存储的文件名称
 */
export function saveHtmlElementAs(el, filename) {
    return takeHtmlSnapshoot(el)
        .then(function (base64Data) {
        return base64ToBlob(base64Data);
    })
        .then(function (blob) {
        return downloadBlob(blob, filename);
    })
        .then(function () {
        var canvasEle = canvasId ? document.querySelector('#' + canvasId) : null;
        if (canvasEle && canvasEle.parentElement) {
            canvasEle.parentElement.removeChild(canvasEle);
            canvasId = null;
        }
    });
}
/**
 * 以某个元素为根节点，截图并保存到相册
 * @param el
 * @returns
 */
export function saveToAlbum(el) {
    return __awaiter(this, void 0, void 0, function () {
        var base64, uuid, fileObj, res, url, isAndroid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!el) {
                        console.error('元素不存在~');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, takeHtmlSnapshoot(el)
                        // 生成一个临时文件名
                    ];
                case 1:
                    base64 = _a.sent();
                    uuid = nanoid(12);
                    fileObj = base64ToFile(base64, "temp-".concat(format(new Date(), 'yyyy/MM/dd/hh/mm/ss'), "-").concat(uuid, ".png"));
                    if (!fileObj) {
                        console.error('文件对象生成失败');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, upload({
                            file: fileObj,
                        })];
                case 2:
                    res = _a.sent();
                    url = res.data.url;
                    if (!url) {
                        console.error('文件上传失败~');
                        return [2 /*return*/];
                    }
                    isAndroid = env.browser.isAndroid;
                    bridge.openPage('changba://?ac=saveImage&imageURL=' + encodeURIComponent(url), !isAndroid);
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * 图片地址转base64
 * @param url 图片地址
 * @returns
 */
export function imgUrlToBase64(url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.src = url;
        img.crossOrigin = 'anonymous';
        // 让图片保持可见，但是不在可视区范围内
        img.style.position = 'absolute';
        img.style.left = '-10000px';
        img.style.top = '-10000px';
        img.onload = function () {
            var _a;
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            context.drawImage(img, 0, 0);
            var base64Image = canvas.toDataURL('image/jpeg');
            resolve(base64Image);
            (_a = img.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(img);
        };
        img.onerror = reject;
        document.body.appendChild(img);
    });
}
